import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { getRadiologistTemplatesAPI } from '../../../services/typist-service';
import { FETCH_RADIOLOGIST_TEMPLATES, FETCH_RADIOLOGIST_TEMPLATES_ERROR, FETCH_RADIOLOGIST_TEMPLATES_START, FETCH_RADIOLOGIST_TEMPLATES_SUCCESS } from '../../actions/typist/typistWorklistAction';

function* fetchRadiologistTemplates({ radiologistCode }) {
    try {
        yield put({ type: FETCH_RADIOLOGIST_TEMPLATES_START })
        const response = yield call(getRadiologistTemplatesAPI, radiologistCode);
        if (response.success) {
            yield put({ type: FETCH_RADIOLOGIST_TEMPLATES_SUCCESS, radiologistTemplates: response.radiologistTemplates });
        } else {
            if (response.error) {
                yield put({ type: FETCH_RADIOLOGIST_TEMPLATES_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: FETCH_RADIOLOGIST_TEMPLATES_ERROR, error: response.error })
                message.error('Failed to fetch templates for radiologist!');
            }
        }
    } catch (error) {
        yield put({ type: FETCH_RADIOLOGIST_TEMPLATES_ERROR, error })
        message.error('Failed to fetch templates for radiologist!');
    }
}

function* templatesWatcher() {
    yield takeEvery(FETCH_RADIOLOGIST_TEMPLATES, fetchRadiologistTemplates)
}

export default function* rootSaga() {
    yield all([
        templatesWatcher(),
    ]);
}